export type StartupCallback = (firstConnection: boolean) => Promise<void>
export const startupCallbacks: Map<string, StartupCallback> = new Map<string, StartupCallback>();

export function RegisterStartupCallback(key: string, callback: StartupCallback)
{
	startupCallbacks.set(key, callback);
}

export async function Startup(firstConnection: boolean)
{
	for (const [key, callback] of startupCallbacks)
	{
		await callback(firstConnection);
	}
}